<template>
  <v-dialog class="c-cover-dialog" v-model="open" persistent max-width="660px">
    <v-card>
      <v-card-title>
        <span>{{ $T('common.form.create_cover') }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-layout class="c-crop-dialog-layout">
        <div class="c-dialog-main">
          <div class="c-pv-area">
            <div class="c-crop-pv l"></div>
            <div v-if="!leTbS" class="c-crop-pv m"></div>
            <div v-if="!leTbS" class="c-crop-pv s"></div>
          </div>
          <div v-show="crop.prepared" v-if="crop.url" class="c-crop-button-area">
            <v-btn class="btn-r" flat icon color="clr-secondary" @click.native="rotate(-90)">
              <v-icon>rotate_left</v-icon>
            </v-btn>
            <v-btn class="btn-l" flat icon color="clr-secondary" @click.native="rotate(90)">
              <v-icon>rotate_right</v-icon>
            </v-btn>
          </div>
          <div v-show="crop.prepared" v-if="crop.url" class="c-crop-area">
            <div class="c-crop">
              <img id="cropImage" :src="crop.url" @load="setCrop" />
            </div>
          </div>
        </div>
        <spinner id="cropLoading"></spinner>
      </v-layout>
      <v-card-text v-if="crop.errMsg" class="c-crop-err">
        <span>{{ crop.errMsg }}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="closeCrop">{{ $T('button.cancel') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="saveCrop" :disabled="!crop.prepared" :loading="crop.saving">{{
          $T('button.ok')
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Cropper.js is loaded globally from public/js/lib/cropper.min.js (v1.4.0) with its CSS
// (public/css/lib/cropper.min.css), wired up in layouts/spa.html — used here via window.Cropper.

export default {
  props: {
    size: { type: Number, required: true },
    quality: { type: Number, required: false, default: 0.85 },
    dataUrl: { type: String, required: true },
  },
  data() {
    return {
      open: true,
      crop: {
        cropper: null,
        prepared: false,
        saving: false,
        url: this.dataUrl,
        src: null,
        errMsg: null,
      },
    };
  },
  computed: {},
  methods: {
    setCrop: function() {
      var cropImage = document.getElementById('cropImage');

      var cropper = new window.Cropper(cropImage, {
        aspectRatio: 1 / 1,
        preview: '.c-crop-pv',
        minContainerWidth: this.leTbS ? 250 : 300,
        minContainerHeight: this.leTbS ? 250 : 300,
        zoomOnWheel: true,
        // crop: function(event) {
        // console.log(event.detail.x);
        // console.log(event.detail.y);
        // console.log(event.detail.width);
        // console.log(event.detail.height);
        // console.log(event.detail.rotate);
        // console.log(event.detail.scaleX);
        // console.log(event.detail.scaleY);
        // }
      });
      // Get the Cropper.js instance after initialized
      this.crop.cropper = cropper;
      // this.crop.dialog = false;
      this.crop.prepared = true;
      $('#cropLoading').fadeOut();
    },
    rotate: function(degree) {
      this.crop.cropper.rotate(degree);
    },
    closeCrop: function() {
      if (this.crop.cropper != null) {
        this.crop.cropper.destroy();
        this.crop.cropper = null;
      }
      this.crop.prepared = false;
      this.crop.dialog = false;
      this.$emit('cancel');
    },
    saveCrop: function() {
      this.crop.saving = true;
      var canvas = this.crop.cropper.getCroppedCanvas({
        fillColor: '#fff',
      });
      if (canvas.width < 1) {
        this.crop.errMsg = $T('common.form.create_cover_error_too_small');
        this.crop.saving = false;
        return;
      }
      this.crop.src = this.getSrc(canvas, this.size);
      this.$emit('save', this.crop.src, this.crop.exif);
      if (this.crop.cropper != null) {
        this.crop.cropper.destroy();
        this.crop.cropper = null;
      }
      this.crop.dialog = false;
    },
    getSrc: function(canvas, size) {
      if (canvas.width <= size) {
        return canvas.toDataURL('image/jpeg', this.quality);
      }
      return this.$imageUtils.downScaleCanvasClear(canvas, size / canvas.width).toDataURL('image/jpeg', this.quality);
    },
  },
};
</script>
